/* unplugin-vue-components disabled */import { render } from "./ActPage3.vue?vue&type=template&id=2eb09c1c&scoped=true"
import script from "./ActPage3.vue?vue&type=script&lang=js"
export * from "./ActPage3.vue?vue&type=script&lang=js"

import "./ActPage3.vue?vue&type=style&index=0&id=2eb09c1c&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb09c1c"]])

export default __exports__